import styled from "styled-components";

export const UserTrafficWrapper = styled.span`
  padding-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MemberPhoto = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const ConversationHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* Each name takes its own direction, so Arabic and mixed names read in order. */
  span {
    unicode-bidi: plaintext;
  }
`;
